import CellTowerIcon from "@mui/icons-material/CellTower";
import type { SvgIconProps } from "@mui/material/SvgIcon";

export default function DraginoGatewayIcon(props: SvgIconProps) {
    const { color, ...otherProps } = props;
    // Dragino Gateway Icon (DL0S8N)
    return <CellTowerIcon sx={{ color: color }} {...otherProps} />;
}
